import React, { useContext, useEffect, useState } from 'react'
import injectStyles from 'react-jss'
import CloseIcon from '../../../Assets/Images/icons/modalClose'
import { styles } from './styles'
import GenericFlatButton from '../../../Components/GenericFlatButton'
import ChatParticipantsSearch from '../../../Components/ChatParticipantsSearch/container/ChatParticipantsSearch'
import Multiselect from '../../../Components/Multiselect'
import { MenuItem } from 'material-ui'
import { Select } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { hideReduxModal } from '../../../Reducers/UI/actions'
import { SnackBarContext } from 'Components/SnackBar'
import { authorization } from '../../../Module/Auth/Auth'
import {
  ROLE_ADMIN,
  ROLE_DISTRIBUTOR,
  ROLE_SPY,
} from '../../../shared/constants'

const CreateConversationModal = ({
  cities,
  citiesList,
  handleCreateConversation,
  searchRequestHandler,
  classes,
}) => {
  const [selectedCities, setSelectedCities] = useState(['All'])
  const [selectedRole, setSelectedRole] = useState('All')
  const [selectedParticipants, setSelectedParticipants] = useState([])
  const [loading, setLoading] = useState(false)
  const [cityIds, setCityIds] = useState([])

  useEffect(() => {
    if (selectedCities.filter(city => city == 'All').length > 0) return
    const cityIds = selectedCities.reduce((acc, name) => {
      const { id } = cities.find(({ name: cityName }) => name == cityName)
      if (id) {
        acc.push(id)
      }
      return acc
    }, [])
    setCityIds(cityIds)
  }, [selectedCities])

  const user = authorization.getUser()

  const dispatch = useDispatch()
  const baOptions = [
    { key: 'BA', value: ROLE_DISTRIBUTOR },
    { key: 'Spy', value: ROLE_SPY },
    { key: 'All', value: 'All' },
  ]

  const runSnackBar = useContext(SnackBarContext)

  return (
    <div className={classes.container}>
      <div className={classes.title} cypress_id={'newChatTitle'}>
        New chat
      </div>
      <div
        className={classes.closeIcon}
        onClick={() => dispatch(hideReduxModal())}
      >
        <CloseIcon />
      </div>
      <div className={classes.wrapper}>
        <div className={classes.filterContainer}>
          <div className={classes.roleSelectorTitle}>Role</div>
          <div className={classes.citySelectContainer}>
            <Select
              disableUnderline
              value={selectedRole}
              onChange={event => {
                setSelectedRole(event.target.value)
              }}
              style={{
                width: 210,
                height: 36,
                border: 'none',
              }}
            >
              {baOptions.map(({ key, value }) => {
                return (
                  <MenuItem
                    key={key}
                    value={value}
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    {key}
                  </MenuItem>
                )
              })}
            </Select>
          </div>
          {user.role == ROLE_ADMIN && (
            <Multiselect
              hideClearButton={true}
              customContainerStyle={classes.customSelectContainer}
              selectedCities={selectedCities}
              setSelectedCities={setSelectedCities}
              citiesList={citiesList}
              customSelectStyle={{ width: 210, flexWrap: 'wrap' }}
              chipContainerStyle={classes.chipContainerStyle}
              title={'City'}
              placeholder={'Select city...'}
            />
          )}
        </div>
        <div className={classes.searchContainer}>
          <ChatParticipantsSearch
            style={{
              height: '34px',
              boxShadow: 'unset',
              width: '100%',
              minWidth: '82px',
            }}
            showButton={true}
            placeholder="Who would you like to add?"
            onSuggestionSelected={() => {}}
            searchRequestHandler={searchRequestHandler}
            selectedParticipants={selectedParticipants}
            setSelectedParticipants={setSelectedParticipants}
            selectedRole={selectedRole == 'All' ? null : selectedRole}
            cityIds={cityIds}
          />
        </div>
      </div>

      <div
        className={classes.buttonContainer}
        cypress_id={'createChatBtnContainer'}
      >
        <GenericFlatButton
          type={'filled'}
          title={'Create'}
          onClick={async () => {
            try {
              setLoading(true)
              await handleCreateConversation(selectedParticipants)
              runSnackBar({
                type: 'success',
                vertical: 'top',
                msg: 'Chat created!',
              })
              dispatch(hideReduxModal())
            } catch (error) {
              runSnackBar({
                type: 'error',
                vertical: 'top',
                msg: 'Chat creation failed!',
              })
            }
          }}
          customStyles={classes.button}
          loading={loading}
          disabled={selectedParticipants.length == 0}
        />
      </div>
    </div>
  )
}

export default injectStyles(styles)(CreateConversationModal)
